import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Dimensions,
    ScrollView,
    Modal,
    Platform,
    Alert,
    Text
} from "react-native";
import { Image } from 'expo-image'
import { SafeAreaInsetsContext } from "react-native-safe-area-context";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import * as Animatable from "react-native-animatable";
import * as ServerOperations from "../utils/ServerOperations";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
import InvoiceDetails from "./InvoiceDetails";
import OrderDetails from "./OrderDetails";
import DateTimePicker from 'react-native-modal-datetime-picker';
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let styles = {};
let isMobile = false;
let scale = 1;
const CloseIcon = require("../images/InvoiceDetails/closeIcon.png");
const imgCalender = require("../images/StatementOfAccount/calender.png");
const imgArrowDown = require("../images/MyOrders/OrderArrowDown.png");
const closeIcon = require("../images/CheckOut/closeIcon.png");
class MyOrders extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showOrderDetails: false,
            showMyOrdersMainScreen: false,
            selectedFromDate: "",
            selectedToDate: "",
            fromDateStyle: AppStyles.dateTextStyle2,
            toDateStyle: AppStyles.dateTextStyle2,
            orders: [],
            ordersDetails: [],
            orderTimeline: [],
            detailsOrderNo: '',
            detailsInvoiceNo: '',
            detailsOrderDate: '',
            showOrderTimeline: false,
            orderTimelineLastItem: [],
            showInvoiceDetails: false,
            flag: 0,
            ordersDesktop: [],
            isOther: false,
            showCancelConfirmation: false,
            showFromDatePicker: false,
            showToDatePicker: false,

        };
    }
    Pressables = {};


    async componentDidMount() {
        if (typeof window !== 'undefined' && window.addEventListener) {
            window.addEventListener('popstate', this.handleBackButton);

            // Push current state to history for better navigation
            const currentState = {
                page: 'MyOrders',
                timestamp: Date.now()
            };
            window.history.pushState(currentState, 'My Orders', window.location.pathname);
        }
        this.loadOrders();
    }


    componentWillUnmount() {
        // Clean up event listener
        if (typeof window !== 'undefined' && window.removeEventListener) {
            window.removeEventListener('popstate', this.handleBackButton);
        }
    }

    handleBackButton = (event) => {
        // Handle back button press - close product details
        this.setState({ showOrderDetails: false });

        // Prevent default browser back behavior if needed
        // You can remove this if you want normal browser back behavior
        if (event.state && event.state.page === 'MyOrders') {
            // Custom handling - stay on current page but close modal/details
            window.history.pushState(event.state, 'My Orders', window.location.pathname);
        } else if (isMobile) {
            window.location = './shop';
        }
    }

    loadOrders = async () => {
        loaderHandler.showLoader(STRINGS.loading, this);
        let resp = await ServerOperations.getOrders(this.state.selectedFromDate, this.state.selectedToDate, '');
        this.setState({ orders: resp.ORDS, selectedFromDate: resp.FROM_DATE, selectedToDate: resp.TO_DATE, flag: 1, showMyOrdersMainScreen: true });
        loaderHandler.hideLoader();
    }

    getLastOrderItem = () => {
        const TimelineCount = this.state.orderTimeline.length;
        const orderTimelineLastItem = this.state.orderTimeline.map((order, index) => (
            <View>
                {index == TimelineCount - 1 && (order.COLOR == '#6ba461' || order.COLOR == '#D70202') && TimelineCount - 1 != 0 && (
                    <View style={{ alignSelf: 'stretch', paddingHorizontal: 13, marginTop: 30 }}>
                        <View style={{ flexDirection: 'row', gap: 8, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch', flexDirection: 'column' }}>
                                <View style={{ height: 40, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)', justifyContent: 'center', alignItems: 'center' }} />
                                <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                            </View>
                            <View style={{ justifyContent: 'center', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
                {index == TimelineCount - 1 && order.COLOR != '#6ba461' && order.COLOR != '#D70202' && (
                    <View style={{ alignSelf: 'stretch', paddingHorizontal: 22, marginTop: 30 }}>
                        <View style={{ flexDirection: 'row', gap: 16, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch' }}>
                                <View style={{ height: 70, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)', justifyContent: 'center', alignItems: 'center' }}>
                                    <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                                </View>
                            </View>
                            <View style={{ justifyContent: 'center', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
            </View>
        ));
        return orderTimelineLastItem;
    };


    renderHeaderMobile = () => {
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between" }}>
                {/* <TouchableOpacity onPress={() => window.location = './ClientHomePage'}>
                    <Image source={imgJdsLogo} style={{
                        width: 35.063,
                        height: 37,
                        padding: 1,
                        resizeMode: "contain",
                    }} />
                </TouchableOpacity> */}
                <View></View>
                <Text style={[AppStyles.H2Styles]}>{STRINGS.Orders}</Text>
                <View></View>
                {/* <TouchableOpacity onPress={() => window.location = './profile'}>
                    <Image source={imgProfile} style={{ width: 20, height: 20, stroke: Styles.appColor1 }}></Image>
                </TouchableOpacity> */}
            </View>
        )
    }

    renderCancelOrderConfirmation = () => {
        return (
            <Modal
                visible={this.state.showOnHoldPopUp}
                transparent={true}
                animationType="fade"
                onRequestClose={() => this.setState({ showOnHoldPopUp: false })}
            >
                <View
                    style={{
                        flex: 1,
                        backgroundColor: 'rgba(255,255,255,0.4)', // white with opacity
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <View
                        style={{
                            backgroundColor: '#fff',
                            padding: 24,
                            width: width * 0.8,
                            maxWidth: 400,
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: 16,
                            borderWidth: 1,
                            borderColor: 'rgba(215, 215, 215, 0.50)',
                        }}
                    >
                        <TouchableOpacity
                            style={{
                                position: 'absolute',
                                right: 12,
                                top: 12,
                                zIndex: 10,
                            }}
                            onPress={() => this.setState({ showCancelConfirmation: false })}
                        >
                            <Image source={closeIcon} style={{ width: 16, height: 16 }} />
                        </TouchableOpacity>
                        <Text style={[AppStyles.accountHoldHeader, { marginTop: 15, textAlign: 'center' }]}>
                            {STRINGS.cancel_order_msg}
                        </Text>
                        <Text style={[AppStyles.accountHoldText, { marginBottom: 24, marginTop: 16 }]}>
                            {STRINGS.cancel_Question}
                        </Text>
                        <TouchableOpacity
                            style={
                                [AppStyles.loginButtonStyles,
                                { paddingVertical: 10, paddingHorizontal: 32, backgroundColor: '#D70202' }]
                            }
                            onPress={async () => {
                                this.setState({ showCancelConfirmation: false });
                                // Call the cancel order API
                                const response = await ServerOperations.cancelOrder(this.state.selectedOrderId, this.state.selectedInvoiceId);
                                if (response && response.ERROR == false) {
                                    // Handle successful cancellation
                                    loaderHandler.showLoader(STRINGS.loading, this);
                                    await this.loadOrders();
                                    loaderHandler.hideLoader();
                                } else {
                                    // Handle error
                                    Alert.alert(STRINGS.ERROR, response.MSG || STRINGS.cancel_order_failed);
                                    console.error('Failed to cancel order:', response);
                                }
                            }}
                        >
                            <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.cancel_order}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </Modal>
        )
    }



    renderMobile() {
        scale = width / 420;
        return (
            <View style={styles.container}>
                {this.state.showOrderDetails == false && this.renderHeaderMobile()}
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width, }}>
                        {Commons.loadFonts(this, false)}
                        {Styles.renderVSeparator(0)}
                        {this.renderPart1Mobile()}
                        {this.state.showMyOrdersMainScreen == true && this.renderPart2Mobile()}
                        {this.state.showCancelConfirmation && this.renderCancelOrderConfirmation()}
                    </View>
                </ScrollView>
                {this.state.isOther && Commons.renderOtherView(this, this.state.isOther)}
                {this.state.isOther && Commons.renderAppFooter({}, this, '', '', '', '#52C0EE')}
                {!this.state.isOther && Commons.renderAppFooter({}, this, '', '', '#52C0EE')}
                {this.state.showOrderDetails == true && this.renderOrderDetailsMobile()}
                <DateTimePicker
                    mode="date"
                    isVisible={this.state.showFromDatePicker}
                    onConfirm={(date) => {
                        this.setState({ selectedFromDate: Commons.formatDateLocal(date), showFromDatePicker: false });
                    }}
                    onCancel={() => this.setState({ showFromDatePicker: false })}
                />
                <DateTimePicker
                    mode="date"
                    isVisible={this.state.showToDatePicker}
                    onConfirm={(date) => {
                        this.setState({ selectedToDate: Commons.formatDateLocal(date), showToDatePicker: false });
                    }}
                    onCancel={() => this.setState({ showToDatePicker: false })}
                />
            </View >
        );
    }

    render() {
        width = Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        if (isMobile) {
            Commons.resizeHandle(window, this, () => {
                width = this.width;
                height = this.height;
            });
            styles = this.styles();
            return this.renderMobile();
        }
        if (!this.props.self) {
            window.location = './ClientHomePage?tab=' + STRINGS.Orders;
            return;
        } else {
            this.props.self.currentComponent = this;
        }
        width = (Commons.getDesktopWidth());
        height = (Commons.getDesktopHeight());
        styles = this.styles();
        return (
            <View style={[styles.container, { backgroundColor: '#FBFEFF' }]}>
                {/* {Commons.renderAppHeader('', this, true, '', '', '', '', '', '')} */}
                <View style={{ flex: 1, flexDirection: 'row', gap: 20, backgroundColor: AppStyles.desktopBackgroundColor, height: '100%', width: '100%' }}>
                    {this.state.showCancelConfirmation && this.renderCancelOrderConfirmation()}
                    {this.state.showOrderDetails &&
                        <OrderDetails
                            self={this}
                            OrderNumber={this.state.detailsOrderNo}
                            InvoiceNumber={this.state.detailsOrderInvoice}
                            InvoiceID={this.state.detailsOrderInvoiceID}
                            OrderDate={this.state.detailsOrderDate}
                            InvoiceAmount={this.state.InvoiceValue}
                            showOrderDetails={(show) => { this.setState({ showOrderDetails: show }); this.props.self.setState({ style: { opacity: 1 } }); }} />
                    }
                    {!this.state.showOrderDetails &&
                        <View style={{ width: this.state.width, maxWidth: 912 }}>
                            <Text style={[AppStyles.H2Styles, { marginLeft: 50, marginTop: 80 }]}>{STRINGS.Orders}</Text>
                            <View style={{ flexDirection: 'row', gap: 20, marginHorizontal: 50, marginTop: 32 }}>
                                {this.renderDateSelection()}
                                {this.renderRequestButton('myorders')}
                            </View>

                            {this.state.flag == 1 && (
                                <ScrollView style={{ height: height - 230, marginTop: 40, width: width }} showsVerticalScrollIndicator={false}>
                                    {this.renderOrderDesktop()}
                                </ScrollView>
                            )}

                        </View>
                    }
                </View>
            </View>

        )
    }

    renderOrderDesktop = () => {
        const OrdersList = this.state.orders.map((order, index) => (
            <View key={order.ORD_NO} style={{ maxWidth: 912, }}>
                {(index == 0 || this.state.orders[index - 1].MONTH != order.MONTH) && (
                    <Text style={[AppStyles.H2Styles, { paddingVertical: 16, fontSize: 16, marginHorizontal: 66 }]}>{order.MONTH}</Text>
                )}

                <TouchableOpacity style={[AppStyles.AllOrdersStyle,
                {
                    backgroundColor: order.BACKGROUND || '#fff',
                    flexGrow: 1, marginHorizontal: 50, marginTop: (index == 0 || this.state.orders[index - 1].MONTH != order.MONTH) ? 0 : 16
                }]}
                    onPress={() => {
                        // loaderHandler.showLoader(STRINGS.loading, this.props.self);
                        // await this.getOrderDetails(order.ORD_NO);
                        this.setState({
                            detailsOrderNo: order.ORD_NO, detailsOrderDate: order.EST_DLV,
                            detailsOrderInvoice: order.INV_NO, detailsOrderInvoiceID: order.INV_ID,
                            showOrderDetails: true, showOrderTimeline: false, InvoiceValue: order.VALUE,
                        });
                        if (typeof window !== 'undefined') {
                            window.history.pushState({
                                page: 'MyOrders',
                            }, 'My Orders', window.location.pathname);
                        }
                        this.props.self.setState({ style: { opacity: 0.3 } });
                        // loaderHandler.hideLoader();
                    }}>

                    <View style={{ gap: 8, alignSelf: 'stretch' }}>
                        <Text style={{ height: 10 }}></Text>
                        <Text style={[AppStyles.BodyTextStyles]}>Order #{order.ORD_NO}</Text>
                        <Text style={[AppStyles.SecondaryTextStyles, { color: 'rgba(20, 36, 46, 0.62)' }]}>Est Delivery: {order.EST_DLV}</Text>
                        <Text style={[AppStyles.SecondaryTextStyles, { color: 'rgba(20, 36, 46, 0.62)' }]}>Entry Source: {order.SOURCE}</Text>
                        <Text style={[AppStyles.SecondaryTextStyles, { color: 'rgba(20, 36, 46, 0.62)' }]}>Order Value: {order.VALUE}</Text>
                        {order.STATUS !== "Shipped" && order.MONTH === 'Active Orders' && (
                            <TouchableOpacity style={{ marginVertical: 5 }}
                                onPress={() => { this.setState({ showCancelConfirmation: true, selectedOrderId: order.ORD_NO, selectedInvoiceId: order.INV_ID }) }}>
                                <Text style={[AppStyles.cancelText, { textDecorationLine: 'underline' }]}>{STRINGS.cancel_order}</Text>
                            </TouchableOpacity>
                        )}
                        <Text style={{ height: 10 }}></Text>
                    </View>
                    <View style={{ display: 'flex', width: 90, flexDirection: 'column', alignItems: 'center', gap: 8 }}>
                        <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                        <Text style={[AppStyles.H3Styles, { textAlign: 'center' }]}>{order.STATUS}</Text>
                    </View>
                </TouchableOpacity>
            </View>
        ));
        return OrdersList;
    }


    renderRequestButton = (type) => {
        return (
            <TouchableOpacity style={[AppStyles.primaryButtonStyle, { width: 109 }]}
                onPress={async () => {
                    loaderHandler.showLoader(STRINGS.loading, this);
                    if (type == 'myorders') { await this.loadOrders(); this.setState({ flag: 1 }) }
                    loaderHandler.hideLoader();
                }}>
                <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.Request}</Text>
            </TouchableOpacity>
        )
    }

    renderDateSelection = () => {
        return (
            <View style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 7, flexDirection: 'row' }}>

                <TouchableOpacity
                    onPress={() => {
                        if (Platform.OS === 'web') {
                            this.fromDateInput.showPicker();
                        } else {
                            this.setState({ showFromDatePicker: true });
                        }
                    }}
                    style={{
                        display: 'flex', height: 42, flexDirection: 'row', width: 265, justifyContent: 'space-between',
                        alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.50)'
                    }}>
                    <Text style={[AppStyles.FromToDateTextStyle, { position: 'absolute', top: -10, left: 10, backgroundColor: AppStyles.desktopBackgroundColor, width: 35 }]}>{STRINGS.from}</Text>
                    <Text style={[AppStyles.dateTextStyle2, { paddingHorizontal: 10 }]}>{this.state.selectedFromDate}</Text>
                    <Image source={imgCalender} style={{ width: 17, height: 17, marginRight: 10 }} />
                    {Platform.OS === 'web' && (
                        <input
                            ref={e => this.fromDateInput = e}
                            type="date"
                            value={this.state.selectedFromDate}
                            onChange={(e) => this.setState({ selectedFromDate: e.target.value, })}
                            style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }}

                        />
                    )}
                </TouchableOpacity>

                <TouchableOpacity
                    onPress={() => {
                        if (Platform.OS === 'web') {
                            this.toDateInput.showPicker();
                        } else {
                            this.setState({ showToDatePicker: true });
                        }
                    }}
                    style={{
                        display: 'flex', height: 42, flexDirection: 'row', width: 265, justifyContent: 'space-between',
                        alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.50)',
                    }}>
                    <Text style={[AppStyles.FromToDateTextStyle, { position: 'absolute', top: -10, left: 10, backgroundColor: AppStyles.desktopBackgroundColor, width: 20 }]}>{STRINGS.to}</Text>
                    <Text style={[AppStyles.dateTextStyle2, { paddingHorizontal: 10 }]}>{this.state.selectedToDate}</Text>
                    <Image source={imgCalender} style={{ width: 17, height: 17, marginRight: 10 }} />
                    {Platform.OS === 'web' && (
                        <input
                            ref={e => this.toDateInput = e}
                            type="date"
                            value={this.state.selectedToDate}
                            onChange={(e) => this.setState({ selectedToDate: e.target.value, })}
                            style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }}
                        />
                    )}
                </TouchableOpacity>

                <DateTimePicker
                    mode="date"
                    isVisible={this.state.showFromDatePicker}
                    onConfirm={(date) => {
                        this.setState({ selectedFromDate: Commons.formatDateLocal(date), showFromDatePicker: false });
                    }}
                    onCancel={() => this.setState({ showFromDatePicker: false })}
                />
                <DateTimePicker
                    mode="date"
                    isVisible={this.state.showToDatePicker}
                    onConfirm={(date) => {
                        this.setState({ selectedToDate: Commons.formatDateLocal(date), showToDatePicker: false });
                    }}
                    onCancel={() => this.setState({ showToDatePicker: false })}
                />
            </View>
        )
    }



    renderPart1Mobile = () => {
        return (
            <View style={{ width: width - 40, marginTop: 30, flexDirection: 'column', gap: 30, paddingHorizontal: 20 }}>
                <View style={{ display: 'flex', width: width - 40, justifyContent: 'center', alignItems: 'center', gap: 7, flexDirection: 'row', }}>
                    <TouchableOpacity
                        onPress={() => {
                            if (Platform.OS === 'web') {
                                this.fromDateInput.showPicker();
                            } else {
                                this.setState({ showFromDatePicker: true });
                            }
                        }}
                        style={{
                            display: 'flex', height: 40, flexDirection: 'row', width: '48%', justifyContent: 'space-between',
                            alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.50)',
                        }}>
                        <Text style={[AppStyles.FromToDateTextStyle, { position: 'absolute', top: -10, left: 10, backgroundColor: AppStyles.desktopBackgroundColor, width: 35 }]}>{STRINGS.from}</Text>
                        <Text style={[this.state.fromDateStyle, { paddingHorizontal: 10 }]}>{this.state.selectedFromDate}</Text>
                        <Image source={imgCalender} style={{ width: 17, height: 17, marginRight: 10 }} />
                        {Platform.OS === 'web' && (
                            <input
                                ref={e => this.fromDateInput = e}
                                type="date"
                                value={this.state.selectedFromDate}
                                onChange={(e) => { this.setState({ selectedFromDate: e.target.value, fromDateStyle: AppStyles.dateTextStyle2, showMyOrdersMainScreen: false }); console.log(this.state.selectedFromDate) }}
                                style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }}

                            />
                        )}
                    </TouchableOpacity>

                    <TouchableOpacity
                        onPress={() => {
                            if (Platform.OS === 'web') {
                                this.toDateInput.showPicker();
                            } else {
                                this.setState({ showToDatePicker: true });
                            }
                        }}
                        style={{ display: 'flex', height: 40, flexDirection: 'row', width: '48%', justifyContent: 'space-between', alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.50)' }}>
                        <Text style={[AppStyles.FromToDateTextStyle, { position: 'absolute', top: -10, left: 10, backgroundColor: AppStyles.desktopBackgroundColor, width: 20 }]}>{STRINGS.to}</Text>
                        <Text style={[this.state.toDateStyle, { paddingHorizontal: 10 }]}>{this.state.selectedToDate}</Text>
                        <Image source={imgCalender} style={{ width: 17, height: 17, marginRight: 10 }} />
                        {Platform.OS === 'web' && (
                            <input
                                ref={e => this.toDateInput = e}
                                type="date"
                                value={this.state.selectedFromDate}
                                onChange={(e) => this.setState({ selectedToDate: e.target.value, toDateStyle: AppStyles.dateTextStyle2, showMyOrdersMainScreen: false })}
                                style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }}
                            />
                        )}
                    </TouchableOpacity>
                </View>
                {/* {!this.state.showMyOrdersMainScreen == false && ( */}
                <TouchableOpacity style={[AppStyles.loginButtonStyles, { width: width - 40 }]}
                    onPress={async () => {
                        loaderHandler.showLoader(STRINGS.loading, this);
                        await this.loadOrders();
                        this.setState({ showMyOrdersMainScreen: true })
                        loaderHandler.hideLoader();
                    }}>
                    <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.Request}</Text>
                </TouchableOpacity>
                {/* )} */}
            </View>
        )
    }

    renderPart2 = () => {

    }

    getOrderDetails = async (orderNo) => {
        let resp = await ServerOperations.getOrders(this.state.selectedFromDate, this.state.selectedToDate, orderNo);
        this.setState({ ordersDetails: resp.ITEMS, orderTimeline: resp.TIMELINE });
    }

    renderPart2Mobile = () => {
        const OrdersList = this.state.orders.map((order, index) => (
            <View key={order.ORD_NO}>
                {(index == 0 || this.state.orders[index - 1].MONTH != order.MONTH) && (
                    <Text style={[AppStyles.H2Styles, { marginBottom: 16, marginLeft: 8 }]}>{order.MONTH}</Text>
                )}
                <TouchableOpacity
                    style={[
                        AppStyles.AllOrdersStyle,
                        {
                            width: width - 40,
                            backgroundColor: '#fff',
                            paddingBottom: 16,
                            shadowColor: '#202020',
                            shadowOffset: { width: 5, height: 5 },
                            shadowOpacity: 0.03,
                            shadowRadius: 15,
                            elevation: 3
                        }
                    ]}
                    onPress={async () => {
                        loaderHandler.showLoader(STRINGS.loading, this);
                        await this.getOrderDetails(order.ORD_NO);
                        this.setState({
                            detailsOrderNo: order.ORD_NO,
                            detailsOrderDate: order.EST_DLV,
                            detailsOrderInvoice: order.INV_NO,
                            detailsOrderInvoiceID: order.INV_ID,
                            showOrderDetails: true,
                            showOrderTimeline: false,
                            InvoiceValue: order.VALUE
                        });
                        if (typeof window !== 'undefined') {
                            window.history.pushState({
                                page: 'MyOrders',
                            }, 'My Orders', window.location.pathname);
                        }
                        loaderHandler.hideLoader();
                    }}>
                    <View style={{ gap: 8, alignSelf: 'stretch' }}>
                        <Text style={{ height: 10 }}></Text>
                        <Text style={[AppStyles.BodyTextStyles]}>Order #{order.ORD_NO}</Text>
                        <Text style={[AppStyles.SecondaryTextStyles, { color: 'rgba(20, 36, 46, 0.62)' }]}>Est Delivery: {order.EST_DLV}</Text>
                        <Text style={[AppStyles.SecondaryTextStyles, { color: 'rgba(20, 36, 46, 0.62)' }]}>Entry Source: {order.SOURCE}</Text>
                        <Text style={[AppStyles.SecondaryTextStyles, { color: 'rgba(20, 36, 46, 0.62)' }]}>Order Value: {order.VALUE}</Text>
                        {order.STATUS !== "Shipped" && order.MONTH === 'Active Orders' && (
                            <TouchableOpacity style={{ marginVertical: 5 }}
                                onPress={() => { this.setState({ showCancelConfirmation: true, selectedOrderId: order.ORD_NO, selectedInvoiceId: order.INV_ID }) }}>
                                <Text style={[AppStyles.cancelText, { textDecorationLine: 'underline' }]}>{STRINGS.cancel_order}</Text>
                            </TouchableOpacity>
                        )}
                        <Text style={{ height: 10 }}></Text>
                    </View>
                    <View style={{ display: 'flex', width: 90, flexDirection: 'column', alignItems: 'center', gap: 8 }}>
                        <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                        <Text style={[AppStyles.H3Styles, { textAlign: 'center' }]}>{order.STATUS}</Text>
                    </View>
                </TouchableOpacity>
            </View>
        ));
        return (
            <View style={{ alignItems: "flex-start", gap: 16, alignSelf: 'stretch', paddingHorizontal: 20, marginTop: 30 }}>
                {OrdersList}
                <Text style={{ height: 56 }}></Text>
            </View>
        )
    }

    renderOrderDetails = () => {

    }

    renderOrderDetailsMobile = () => {
        var TimelineCount = this.state.orderTimeline.length;
        const OrderTimeline = this.state.orderTimeline.map((order, index) => (
            <View>
                {index < TimelineCount - 1 && (
                    <View style={{ alignSelf: 'stretch', paddingHorizontal: 22 }}>
                        <View style={{ flexDirection: 'row', gap: 16, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch' }}>
                                <View style={{
                                    height: 130, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)',
                                    justifyContent: 'center', alignItems: 'center'
                                }}>
                                    <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                                </View>
                            </View>
                            <View style={{ justifyContent: 'center', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
                {index == TimelineCount - 1 && (order.COLOR == '#6ba461' || order.COLOR == '#D70202') && TimelineCount - 1 != 0 && (
                    <View style={{ alignSelf: 'stretch', paddingHorizontal: 13 }}>
                        <View style={{ flexDirection: 'row', gap: 8, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch', flexDirection: 'column' }}>
                                <View style={{ height: 70, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)', justifyContent: 'center', alignItems: 'center' }} />
                                <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                            </View>
                            <View style={{ justifyContent: 'center', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
                {index == TimelineCount - 1 && order.COLOR != '#6ba461' && order.COLOR != '#D70202' && (
                    <View style={{ alignSelf: 'stretch', backgroundColor: '#FFF', paddingHorizontal: 22 }}>
                        <View style={{ flexDirection: 'row', gap: 16, alignSelf: 'stretch' }}>
                            <View style={{ alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch' }}>
                                <View style={{ height: 130, width: 4, backgroundColor: 'rgba(37, 89, 126, 0.09)', justifyContent: 'center', alignItems: 'center' }}>
                                    <View style={{ width: 22, height: 22, borderRadius: 360, backgroundColor: order.COLOR }}></View>
                                </View>
                            </View>
                            <View style={{ justifyContent: 'center', flex: 1 }}>
                                <Text style={[AppStyles.H3Styles]}>{order.STATUS}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.COMMENT}</Text>
                                <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 35, 46, 0.62)' }]}>{order.DATE} </Text>
                            </View>
                        </View>
                    </View>
                )}
            </View>
        ));


        const OrderDetails = this.state.ordersDetails.map((order) => (
            <View style={[AppStyles.InvoiceDetailsMainViewStyle, { paddingHorizontal: 20, marginTop: 32 }]}>
                <View style={{ display: 'flex', alignItems: 'center', gap: 24, flexDirection: 'row', width: width - 40 }}>
                    <View style={{ flexDirection: 'column', gap: 6 }}>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Item}</Text>
                        {Commons.getTextWidth(order.ITEM_CODE) > (width - 180) && <Text style={[[AppStyles.InvoiceDetailsItemsStyle]]}>  </Text>}
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Qty_Details}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Price_Details}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Expiry}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>{STRINGS.Batch}</Text>
                    </View>
                    {(order.RELEASED_STATUS == 'B' || order.RELEASED_STATUS == 'D') && (
                        <View style={{ flexDirection: 'column', gap: 6 }}>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle2, { fontWeight: '400', textDecorationLine: 'line-through', maxWidth: width - 130 }]}>{order.ITEM_CODE}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>0</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{order.PRICE}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>-</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>-</Text>
                        </View>
                    )}
                    {(order.RELEASED_STATUS == 'B' || order.RELEASED_STATUS == 'D') && (
                        <View style={{ display: 'flex', position: 'absolute', right: 32, flexDirection: 'column', gap: 5, marginTop: 80, width: 100 }}>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751, textDecorationLine: 'line-through', }]}>{STRINGS.Tax_invoice} {order.TAX}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751, textDecorationLine: 'line-through', }]}>{STRINGS.Total_invoice} {order.TOTAL}</Text>
                        </View>
                    )}

                    {(order.RELEASED_STATUS != 'B' && order.RELEASED_STATUS != 'D') && (
                        <View style={{ flexDirection: 'column', gap: 6 }}>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400', maxWidth: width - 130 }]}>{order.ITEM_CODE}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{order.QTY}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{order.PRICE}</Text>
                            <Text numberOfLines={1} style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400', maxWidth: width - 180 }]}>{Commons.formatExpiryDate(order.EXP_DATE)}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{order.BATCH}</Text>
                        </View>
                    )}
                    {(order.RELEASED_STATUS != 'B' && order.RELEASED_STATUS != 'D') && (
                        <View style={{ display: 'flex', position: 'absolute', right: 32, flexDirection: 'column', gap: 5, marginTop: 80, width: 100 }}>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751, }]}>{STRINGS.Tax_invoice} {order.TAX}</Text>
                            <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751 }]}>{STRINGS.Total_invoice} {order.TOTAL}</Text>
                        </View>
                    )}
                </View>
                <Text style={{}}></Text>
            </View>
        ));
        if (this.state.showInvoiceDetails) {
            return <View style={{ position: 'absolute', top: 0, left: 0, width, height, zIndex: 9005, backgroundColor: AppStyles.desktopBackgroundColor }}>
                <View style={{ position: 'absolute', right: 20, top: 60, zIndex: 9006 }}>
                    {this.renderBackButton(() => this.setState({ showInvoiceDetails: false }))}
                </View>
                <InvoiceDetails
                    InvoiceNumber={this.state.detailsOrderInvoice}
                    InvoiceID={this.state.detailsOrderInvoiceID}
                    InvoiceDate={this.state.detailsOrderDate}
                    InvoiceAmount={this.state.InvoiceValue} />
            </View>
        }
        return (
            <Animatable.View
                animation="slideInUp"
                duration={500}
                style={{
                    flex: 1,
                    position: 'absolute',
                    top: '0%',
                    transform: [{ translateX: -(width - 20) / 2 }, { translateY: -237.5 }],
                    zIndex: 1000,
                    flexDirection: 'column',
                    backgroundColor: AppStyles.desktopBackgroundColor,
                    alignItems: 'center',
                    minHeight: '100%'
                }}>
                {this.renderHeaderDialog()}

                <View style={{ display: 'flex', width: width - 40, flexDirection: 'column', paddingHorizontal: 7 }}>
                    <Text style={[AppStyles.H2Styles]}>Order #{this.state.detailsOrderNo}</Text>
                    <View>
                        <TouchableOpacity onPress={async () => {
                            this.setState({ showInvoiceDetails: true });
                        }} style={{ marginTop: 5 }}>
                            <Text style={[AppStyles.ButtonTextStyles, { color: '#50B0FF', textDecorationLine: 'underline' }]}>Invoice #{this.state.detailsOrderInvoice}</Text>
                        </TouchableOpacity>
                        <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(59, 98, 127, 0.50)', marginTop: 10 }]}>{this.state.detailsOrderDate}</Text>
                    </View>
                </View>
                <ScrollView style={{ width: width - 40, marginTop: 32, flexDirection: 'column', gap: 32, height: height - 210 }} showsVerticalScrollIndicator={false}>
                    <TouchableOpacity onPress={() => this.setState({ showOrderTimeline: !this.state.showOrderTimeline })}>
                        <View style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch', paddingHorizontal: 8, flexDirection: 'row', width: width - 40 }}>
                            <Text style={[AppStyles.H3Styles]}>{STRINGS.Order_Timeline}</Text>
                            {this.state.orderTimeline.length > 1 &&
                                <Image source={imgArrowDown} style={[{ width: 9.6, height: 5.8 }, this.state.showOrderTimeline && { transform: [{ rotate: '180deg' }] }]}></Image>}
                        </View>
                        {this.state.showOrderTimeline && (
                            <Animatable.View style={{ flexDirection: 'column', width: width - 40, alignSelf: 'stretch', paddingHorizontal: 8, marginTop: 10 }}
                                animation="slideInDown"
                                duration={600}>
                                {OrderTimeline}
                            </Animatable.View>
                        )}
                        {!this.state.showOrderTimeline && (
                            this.getLastOrderItem()
                        )}
                        <View style={{ display: 'flex', paddingHorizontal: 8, justifyContent: 'flex-start', alignSelf: 'stretch', marginTop: 30 }}>
                            <Text style={[AppStyles.H3Styles]}>{STRINGS.Order_Details}</Text>
                        </View>
                        <View style={{}}>
                            {OrderDetails}
                        </View>
                        <Text style={{ height: 56 }}></Text>
                    </TouchableOpacity>
                </ScrollView>

            </Animatable.View >
        )
    }

    renderBackButton = (onPress) => {
        return (
            <TouchableOpacity
                onPress={onPress}
                activeOpacity={0.6}
                hitSlop={{ top: 24, bottom: 24, left: 24, right: 24 }}
                style={{
                    width: 48,
                    height: 48,
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                <Image source={CloseIcon} contentFit="contain" style={{ width: 20, height: 20 }} />
            </TouchableOpacity>
        )
    }

    renderHeaderDialog = () => {
        return (
            <SafeAreaInsetsContext.Consumer>
                {(insets) => (
                    <View style={{
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        alignSelf: "stretch",
                        width,
                        paddingHorizontal: 16,
                        paddingTop: 12 + Math.max((insets && insets.top) || 0, 12),
                        paddingBottom: 8,
                    }}>
                        {this.renderBackButton(() => this.setState({ showOrderDetails: false }))}
                    </View>
                )}
            </SafeAreaInsetsContext.Consumer>
        )
    }



    styles = () => ({
        container: {
            flex: 1,
            alignItems: "center",
            backgroundColor: AppStyles.desktopBackgroundColor
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: 590,
        }
    });
}



export default MyOrders;
